export const EstadosDocumentos = {
    Firmado: 'FIRMADO CONFORME',
    NoRequiere: 'NO REQUIERE FIRMADO',
    Pendiente: 'NO FIRMADO',
};
